<div class="flex flex-col gap-4">
  <div class="soft-card rounded">
    <div class="soft-overline mb-2">{{ '#WORKHOURS.TITLE' | translate }}</div>
    <div class="text-2xl">
      {{ dayWorkHours()?.hours ?? '00' }}:{{ dayWorkHours()?.minutes ?? '00' }}:{{
      dayWorkHours()?.seconds ?? '00' }}
    </div>
  </div>
  <div class="soft-card rounded">
    <div class="soft-overline mb-2">{{ '#WORKHOURS.WEEK' | translate }}</div>
    <div class="text-2xl">
      {{ weekWorkHours()?.hours ?? '00' }}:{{ weekWorkHours()?.minutes ?? '00' }}:{{
      weekWorkHours()?.seconds ?? '00' }}
    </div>
  </div>
  <div class="soft-card rounded">
    <div class="soft-overline mb-2">{{ '#WORKHOURS.PAUSE' | translate }}</div>
    <div class="text-2xl">
      {{ pauseTime()?.hours ?? '00' }}:{{ pauseTime()?.minutes?? '00' }}
    </div>
  </div>
</div>
